import { Injectable, inject } from "@angular/core";
import { PrimeNGConfig } from "primeng/api";
import { P_US_DATE_FORMAT } from "@platform-app/app/shared/common/constants";

@Injectable({ providedIn: "root" })
export class PrimeNGConfigService {
  private readonly config = inject(PrimeNGConfig);

  overridePrimeNGConfig(): void {
    this.config.setTranslation({ dateFormat: P_US_DATE_FORMAT });
  }
}
